/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiDefMarkdownCheckResult } from '../../models/api-def-markdown-check-result';
import { ApiDefProjectData } from '../../models/api-def-project-data';

export interface OrganizationsGetMarkdownValidationResults$Params {

/**
 * The ID of the organization to retrieve the markdown validation results from
 */
  organizationId: string;

/**
 * The ID of the project to retrieve the markdown validation results from
 */
  projectId: string;

/**
 * The ID of the upload intent to retrieve the markdown validation results from
 */
  uploadIntentId: string;
}

export function organizationsGetMarkdownValidationResults(http: HttpClient, rootUrl: string, params: OrganizationsGetMarkdownValidationResults$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'project'?: ApiDefProjectData;

/**
 * The results of the markdown validation
 */
'results'?: Array<ApiDefMarkdownCheckResult>;
}>> {
  const rb = new RequestBuilder(rootUrl, organizationsGetMarkdownValidationResults.PATH, 'get');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.path('projectId', params.projectId, {});
    rb.path('uploadIntentId', params.uploadIntentId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'project'?: ApiDefProjectData;
      
      /**
       * The results of the markdown validation
       */
      'results'?: Array<ApiDefMarkdownCheckResult>;
      }>;
    })
  );
}

organizationsGetMarkdownValidationResults.PATH = '/organizations/{organizationId}/projects/{projectId}/markdowns/{uploadIntentId}';
